import React from 'react';
import styles from './Typography.module.scss';
import classes from 'classnames';

export interface ITypographyProps {
  children: React.ReactNode;
  size?: TFontSize;
  weight?: TFontWeight;
  color?: TFontColour;
  className?: string;
  inline?: boolean;
  transform?: TTextTransform;
}

export type TFontSize = 'XXL' | 'XL' | 'L' | 'M' | 'S' | 'XS';
export type TFontWeight = 'regular' | 'semi-bold' | 'bold';
export type TFontColour = 'primary' | 'secondary';
export type TTextTransform = 'uppercase' | 'capitalize' | 'uppercase-first-letter';

export const fontElement: Record<TFontSize, string> = {
  XXL: 'h1',
  XL: 'h2',
  L: 'h3',
  M: 'p',
  S: 'p',
  XS: 'p',
};

export const fontWeights: Record<TFontWeight, string> = {
  regular: styles['regular'],
  'semi-bold': styles['semi-bold'],
  bold: styles['bold'],
};

export const fontColours: Record<TFontColour, string> = {
  primary: styles['primary'],
  secondary: styles['secondary'],
};

export const Typography = ({
  children,
  size = 'M',
  weight = 'regular',
  color = 'primary',
  className,
  inline = false,
  transform,
}: ITypographyProps) => {
  return React.createElement(
    fontElement[size],
    {
      className: classes(fontWeights[weight], fontColours[color], {
        [styles.smallParagraph]: size === 'XS',
        [styles.regularParagraph]: size === 'M',
        [styles.inline]: inline,
        [styles[`transform-${transform}`]]: transform,
        [`${className}`]: className,
      }),
    },
    children,
  );
};
